/* BACCI KID BRAVE INTRO V16.6 AUTO-MOUNT — JAVASCRIPT ASSET */

(()=>{document.querySelectorAll('#bk16').forEach((e,i)=>{if(i>0)e.remove()});document.querySelectorAll('.bk16v').forEach((e,i)=>{if(i>0)e.remove()});const V=["https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V0001.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00010.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00011.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00012.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00013.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00014.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00015.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00016.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00018.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00019.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V0002.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00020.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00021.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V00022.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V0003.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V0004.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V0005.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V0006.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V0008.mp4","https://baccikid.b-cdn.net/Bacci%20Avatar%20Shared%20Videos/Bacci%20Introduction%20Video%20-%20V0009.mp4"],A=["https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci_crouching_phone_transparent.png?v=1783611764","https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci_climbing_phone_transparent.png?v=1783611762","https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci_hero_sitting_transparent.png?v=1783570613","https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci_hero_thumbsup_transparent.png?v=1783570616","https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci_hero_flying_reach_transparent.png?v=1783570616","https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci_hero_skyline_icons_transparent.png?v=1783570616","https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci_hero_screen_burst_icons_v2_transparent.png?v=1783570617"],D={note:[["01","Hi, I am Bacci. Pick a color you love, then tap inside the picture to fill it."],["02","This page is for teens, and kind grown-ups can explore it too."],["03","Open the full note for the short guidance and important disclaimer."]],guide:[["01","Pick a color that feels fun, brave, calm, silly, or bright."],["02","Tap inside the picture to fill each space and watch it come alive."],["03","Want the cinematic intro? Tap Watch Bacci and enjoy the loop."]],grown:[["01","Grown-ups, caregivers, educators, and grandparents can join creatively too."],["02","Take only what feels meaningful. Skip anything that does not fit."],["03","This is creative reflection, not therapy, diagnosis, crisis care, or a promised result."]]},$=id=>document.getElementById(id),root=$('bk16'),note=$('b16note'),cards=$('b16cards'),all=$('b16all'),prev=$('b16prev'),pcard=$('b16pcard'),pcardImg=$('b16pcardimg'),cat=$('b16cat'),pbtn=$('b16pauseprev'),stat=$('b16stat'),viewer=$('b16viewer'),full=$('b16full'),count=$('b16count'),soundText=$('b16soundtext'),start=$('b16start'),pfull=$('b16pausefull'),pauseImg=$('b16pauseimg'),pause=$('b16pause'),sound=$('b16sound'),reopen=$('b16reopen');let mode='note',sess=[],pi=0,fi=0,ai=0,muted=true,open=false,inView=false,entered=false;function sh(a){a=a.slice();for(let i=a.length-1;i>0;i--){let j=Math.floor(Math.random()*(i+1));[a[i],a[j]]=[a[j],a[i]]}return a}function sessMake(){let last=localStorage.getItem('bk16last')||'',pool=sh(V);if(pool[0]===last&&pool.length>1)[pool[0],pool[1]]=[pool[1],pool[0]];sess=pool.slice(0,3);localStorage.setItem('bk16last',sess[0]||'');pi=fi=0}function play(v){let p=v.play();if(p&&p.catch)p.catch(()=>{})}function avatarSeed(){let n=parseInt(localStorage.getItem('bk16avatarNext')||'0',10);if(!Number.isFinite(n))n=0;localStorage.setItem('bk16avatarNext',String((n+1)%A.length));return ((n%A.length)+A.length)%A.length}function setAvatar(i){if(!A.length)return;ai=((i%A.length)+A.length)%A.length;let src=A[ai];[cat,pcardImg,pauseImg].forEach(el=>{if(!el)return;el.classList.add('swap');setTimeout(()=>{el.src=src;el.classList.remove('swap')},80)});localStorage.setItem('bk16avatarLive',String(ai))}function nextAvatar(){setAvatar(ai+1)}function render(m){let data=all.checked?[...D.note,...D.guide,...D.grown]:D[m];cards.innerHTML=data.map(x=>`<div class="card"><b>${x[0]}</b><p>${x[1]}</p></div>`).join('');document.querySelectorAll('#bk16 .mode').forEach(b=>b.classList.toggle('on',b.dataset.mode===m&&!all.checked))}function setMode(m){mode=m;all.checked=false;render(m);note.classList.remove('fold');note.scrollIntoView({behavior:'smooth',block:'nearest'});updRe()}function loadPrev(){if(!sess.length)sessMake();let s=sess[pi]||V[0];if(prev.src!==s){prev.src=s;prev.load()}prev.muted=muted;prev.playsInline=true;stat.textContent=muted?'🔇 Sound Off':'🔊 Sound On';stat.setAttribute('aria-pressed',muted?'false':'true');pbtn.textContent='Pause Preview';pcard.classList.remove('on');play(prev)}function nxtPrev(){pi=(pi+1)%sess.length;loadPrev()}function ui(){count.textContent='Clip '+(fi+1)+' of 3';soundText.textContent=muted?'Muted by default':'Sound is on';sound.textContent=muted?'Sound on':'Sound off';pause.textContent=full.paused?'Play':'Pause'}function splash(el,ms){start.classList.remove('on');pfull.classList.remove('on');el.classList.add('on');if(ms)setTimeout(()=>el.classList.remove('on'),ms)}function loadFull(){if(!sess.length)sessMake();full.src=sess[fi]||V[0];full.muted=muted;full.playsInline=true;full.load();ui();splash(start,650);play(full)}function openViewer(){viewer.hidden=false;viewer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';open=true;fi=0;loadFull();if(viewer.requestFullscreen)viewer.requestFullscreen().catch(()=>{})}function closeViewer(){open=false;full.pause();viewer.hidden=true;viewer.setAttribute('aria-hidden','true');document.body.style.overflow='';if(document.fullscreenElement&&document.exitFullscreen)document.exitFullscreen().catch(()=>{})}function nxtFull(){fi=(fi+1)%sess.length;loadFull()}prev.addEventListener('ended',nxtPrev);prev.addEventListener('canplay',()=>play(prev));full.addEventListener('ended',nxtFull);full.addEventListener('play',ui);full.addEventListener('pause',ui);$('b16open').onclick=openViewer;$('b16watch').onclick=openViewer;$('b16notewatch').onclick=openViewer;pbtn.onclick=()=>{if(prev.paused){pcard.classList.remove('on');stat.textContent=muted?'🔇 Sound Off':'🔊 Sound On';stat.setAttribute('aria-pressed',muted?'false':'true');pbtn.textContent='Pause Preview';play(prev)}else{prev.pause();pcard.classList.add('on');stat.textContent=muted?'🔇 Sound Off':'🔊 Sound On';stat.setAttribute('aria-pressed',muted?'false':'true');pbtn.textContent='Play Preview'}};stat.onclick=()=>{muted=!muted;prev.muted=muted;stat.textContent=muted?'🔇 Sound Off':'🔊 Sound On';stat.setAttribute('aria-pressed',muted?'false':'true');if(!prev.paused)play(prev)};$('b16closetop').onclick=closeViewer;$('b16close').onclick=closeViewer;pause.onclick=()=>{if(full.paused){pfull.classList.remove('on');play(full)}else{full.pause();splash(pfull,0)}ui()};sound.onclick=()=>{muted=!muted;full.muted=muted;if(prev)prev.muted=muted;stat.textContent=muted?'🔇 Sound Off':'🔊 Sound On';stat.setAttribute('aria-pressed',muted?'false':'true');ui();if(full.paused){pfull.classList.remove('on');play(full)}};document.querySelectorAll('#bk16 [data-mode]').forEach(b=>b.onclick=()=>setMode(b.dataset.mode));all.onchange=()=>render(mode);function fold(v){note.classList.toggle('fold',v);updRe()}$('b16collapse').onclick=()=>fold(true);$('b16got').onclick=()=>fold(true);reopen.onclick=()=>{fold(false);note.scrollIntoView({behavior:'smooth',block:'start'})};function updRe(){let r=root.getBoundingClientRect();reopen.classList.toggle('on',note.classList.contains('fold')||(r.top<-140&&innerWidth<920))}addEventListener('scroll',updRe,{passive:true});addEventListener('resize',updRe);addEventListener('keydown',e=>{if(!open)return;if(e.key==='Escape')closeViewer();if(e.key===' '){e.preventDefault();pause.click()}if(e.key.toLowerCase()==='m')sound.click()});if('IntersectionObserver' in window){new IntersectionObserver(es=>{es.forEach(e=>{let now=e.isIntersecting&&e.intersectionRatio>.45;if(now&&!inView){if(entered)nextAvatar();entered=true}inView=now})},{threshold:[0,.45,.75]}).observe(root)}ai=avatarSeed();setAvatar(ai);sessMake();render('note');loadPrev()})();

/* =========================================================
BACCI KID V16.6 BRAVE INTEGRATION
CLOSED-FIRST STORY POD + AFTER-COLOR PLACEMENT
========================================================= */
(function(){
  if(window.BacciBraveIntroV166ClosedFirst) return;
  window.BacciBraveIntroV166ClosedFirst=true;

  var root=document.getElementById("bk16");
  if(!root) return;

  var oldIntro=document.getElementById("bk18");
  var oldModal=document.getElementById("bk18Modal");
  var started=false;

  function reducedMotion(){
    try{
      return !!(
        document.documentElement.getAttribute("data-bk-motion")==="calm" ||
        (
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
        )
      );
    }catch(e){
      return false;
    }
  }

  function colorStage(){
    var colorRoot=document.getElementById("bk-hx");
    return colorRoot && colorRoot.querySelector(".bk-stage");
  }

  function movableNode(){
    /*
      AUTO-MOUNT MODE:
      Move only the Story Pod root. Never move the parent
      Shopify section that contains the coloring engine.
    */
    return root;
  }

  function createMini(){
    if(document.getElementById("b16BraveMini")) return;

    var mini=document.createElement("div");
    mini.id="b16BraveMini";
    mini.className="bk16-brave-mini";
    mini.setAttribute(
      "aria-label",
      "Optional Bacci Kid introduction"
    );

    mini.innerHTML=
      '<button class="bk16-brave-mini-card" id="b16BraveMiniOpen" type="button" aria-expanded="false" aria-controls="bk16">'+
        '<span class="bk16-brave-mini-art" aria-hidden="true">'+
          '<img src="https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci_climbing_phone_transparent.png?v=1783611762" alt="">'+
        '</span>'+
        '<span class="bk16-brave-mini-copy">'+
          '<span class="bk16-brave-mini-kicker">💖 Optional Bacci introduction</span>'+
          '<strong>Meet Bacci after you color.</strong>'+
          '<p>Open a short heart-note, quick guide, and cinematic Story Pod only when you are ready.</p>'+
          '<span class="bk16-brave-mini-cta">Open Bacci’s Story Pod <span aria-hidden="true">›</span></span>'+
          '<small class="bk16-brave-mini-note">Closed by default · muted until you choose sound</small>'+
        '</span>'+
      '</button>';

    root.insertBefore(mini,root.firstChild);

    document
      .getElementById("b16BraveMiniOpen")
      .addEventListener("click",expand);
  }

  function stopMedia(){
    [
      document.getElementById("b16prev"),
      document.getElementById("b16full")
    ].forEach(function(video){
      if(!video) return;
      try{
        video.pause();
        video.currentTime=0;
      }catch(e){}
    });
  }

  function closeViewer(){
    var viewer=document.getElementById("b16viewer");
    var full=document.getElementById("b16full");

    if(full){
      try{
        full.pause();
        full.currentTime=0;
      }catch(e){}
    }

    if(viewer){
      viewer.hidden=true;
      viewer.setAttribute("aria-hidden","true");
    }

    document.body.style.overflow="";

    if(
      document.fullscreenElement &&
      document.exitFullscreen
    ){
      document.exitFullscreen().catch(function(){});
    }
  }

  function collapse(options){
    options=options||{};
    closeViewer();
    stopMedia();

    root.classList.add("bk16-closed-first");

    var miniButton=document.getElementById("b16BraveMiniOpen");
    if(miniButton){
      miniButton.setAttribute("aria-expanded","false");
    }

    if(options.scroll){
      root.scrollIntoView({
        behavior:reducedMotion()?"auto":"smooth",
        block:"center"
      });
    }
  }

  function expand(){
    root.classList.remove("bk16-closed-first");

    var miniButton=document.getElementById("b16BraveMiniOpen");
    if(miniButton){
      miniButton.setAttribute("aria-expanded","true");
    }

    var collapseButton=document.getElementById("b16collapse");
    if(collapseButton){
      collapseButton.textContent="Close Story Pod ↑";
    }

    root.scrollIntoView({
      behavior:reducedMotion()?"auto":"smooth",
      block:"start"
    });

    var preview=document.getElementById("b16prev");
    if(preview){
      preview.muted=true;
      var promise=preview.play();

      if(promise && promise.catch){
        promise.catch(function(){});
      }
    }
  }

  function moveAfterColor(){
    var stage=colorStage();
    var node=movableNode();

    if(!stage || !node) return;

    if(stage.nextElementSibling!==node){
      stage.insertAdjacentElement("afterend",node);
    }
  }

  function hideOldIntro(){
    [oldIntro,oldModal].forEach(function(element){
      if(!element) return;

      element.hidden=true;
      element.setAttribute("aria-hidden","true");
      element.style.setProperty("display","none","important");
    });
  }

  function wireCollapse(){
    [
      document.getElementById("b16collapse"),
      document.getElementById("b16got")
    ].forEach(function(button){
      if(
        !button ||
        button.dataset.bkV166Wired==="true"
      ){
        return;
      }

      button.dataset.bkV166Wired="true";

      button.addEventListener("click",function(){
        setTimeout(function(){
          collapse({scroll:true});
        },40);
      });
    });
  }

  function enforce(){
    createMini();
    moveAfterColor();
    hideOldIntro();
    wireCollapse();

    if(!started){
      started=true;
      collapse({scroll:false});
    }
  }

  enforce();

  if("MutationObserver" in window){
    new MutationObserver(function(){
      enforce();
    }).observe(document.documentElement,{
      childList:true,
      subtree:true
    });
  }

  window.addEventListener("pageshow",enforce);

  setTimeout(enforce,400);
  setTimeout(enforce,1200);
  setTimeout(enforce,2800);
})();

/* END BACCI KID V16.6 BRAVE INTEGRATION */
